<template>
  <div :class="['code-chunk', 'grey darken-4', 'pa-2']"><pre><slot /></pre></div>
</template>
<script>
export default {
  name: 'CodeChunk'
}
</script>
<style>
.code-chunk pre
{
  font-family: monospace, monospace;
  font-size: 12px;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/code-chunk.vue